import { render, staticRenderFns } from "./account-menu.vue?vue&type=template&id=256295d4&scoped=true&"
import script from "./account-menu.vue?vue&type=script&lang=js&"
export * from "./account-menu.vue?vue&type=script&lang=js&"
import style0 from "./account-menu.vue?vue&type=style&index=0&id=256295d4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../MultiSiteClient/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256295d4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../MultiSiteClient/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VImg,VList,VListItem,VListItemContent,VListItemIcon,VListItemTitle,VRow})
